import { useEffect } from "react";

export function useBFCacheListener(onRestore: () => void) {
  // Add event listener for "back cached" navigation
  // defines logic that must happen on page load,
  // even when arriving from a back cache
  useEffect(() => {
    const func = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // do something if page loaded from bfcache
        onRestore();
      }
    };
    window.addEventListener("pageshow", func);

    return () => {
      window.removeEventListener("pageshow", func);
    };
  }, [onRestore]);
}
